import http from '@/utils/http.js'
/*
 * @DESC:api接口
 */
const GET_ENVELOPE_LIST = "/api/getEnvelopeList";//获取红包列表
const GET_ENVELOPE_INFO = "/api/getEnlopeInfo";//获取红包详情
const SAVE_ENVELOPE = "/api/saveEnvelope";//保存红包
const GET_ENVELOPE_SHOP_LIST = "/api/getShopEnvelopeList";//获取门店红包交易列表
const DELETE_ENVELOPE = "/api/delEnvelope";//删除红包
const ENVELOPE_STATICS_INFO = "/api/getEnvelopeStaticsInfo";//获取红包统计
const GET_ENVELOPE_RECORD_LIST = "/api/getEnvelopeRecordList";//红包领取记录
const GET_SHOP_ENVELOPE_RECORD = "/api/getShopEnvelopeRecord";//获取单个红包活动下对应各门店红包领取记录列表

export default {
	getEnvelopeList: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(GET_ENVELOPE_LIST, params);
			commit('GET_ENVELOPE_LIST', data);
		} catch(e) {
			throw e
		}
	},
	
	getEnlopeInfo: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(GET_ENVELOPE_INFO, params);
			commit('GET_ENVELOPE_INFO', data);
			return data;
		} catch(e) {
			throw e
		}
	},
	
	saveEnvelope: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			await http.post(SAVE_ENVELOPE, params);
		} catch(e) {
			throw e
		}
	},
	
	getShopEnvelopeList: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(GET_ENVELOPE_SHOP_LIST, params);
			commit('GET_ENVELOPE_SHOP_LIST', data);
			return data;
		} catch(e) {
			throw e
		}
	},
	
	delEnvelope: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			await http.get(DELETE_ENVELOPE, params);
		} catch(e) {
			throw e
		}
	},
	
	getEnvelopeStaticsInfo: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(ENVELOPE_STATICS_INFO, params);
			commit('ENVELOPE_STATICS_INFO', data);
			return data;
		} catch(e) {
			throw e
		}
	},
	
	getEnvelopeRecordList: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(GET_ENVELOPE_RECORD_LIST, params);
			commit('GET_ENVELOPE_RECORD_LIST', data);
		} catch(e) {
			throw e
		}
	},
	
	getShopEnvelopeRecord: async({
		commit,
		dispatch,
		state,
		getters
	}, params={}) => {
		try{
			const data = await http.get(GET_SHOP_ENVELOPE_RECORD, params);
			commit('GET_SHOP_ENVELOPE_RECORD', data);
		} catch(e) {
			throw e
		}
	},
}


// WEBPACK FOOTER //
// ./src/store/mp/marketing/envelope/actions.js